import * as React from 'react';

import './footer.css';

class Footer extends React.Component {
  public render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="content has-text-centered">
            <p>
              Feel free to drop us an email at <a className="has-text-white" href="mailto:info@mentorintech.com">info@mentorintech.com</a>!
            </p>
            <p>
              &copy; 2018 MentorInTech. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/common/footer/Footer.tsx